import React, { useEffect, useState, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Header from "../common/Header";
import Topbar from "../common/Topbar";
import { useSelector } from "react-redux";

export default function CompanyProtectedRoute() {
  const navigate = useNavigate();
  const location = useLocation();
  const companyData = localStorage.getItem("ltmsCompanyData");
  const [className, setClassName] = useState("content");
  const states = useSelector((state) => state);

  const userData = useMemo(() => {
    return companyData ? JSON.parse(companyData) : null;
  }, [companyData]);

  useEffect(() => {
    const isSharePage = location.pathname.includes("/share");
    if (!companyData && !isSharePage) {
      navigate("/company-login");
    }
  }, [companyData, navigate, location.pathname]);

  useEffect(() => {
    setClassName(
      states?.collapsable?.collapsed ? "collapsedContent" : "content"
    );
  }, [states.collapsable.collapsed]);

  return (
    <>
      <Header userType="company" />
      <div className={className}>
        <Topbar userType="company" userData={userData} />
        <div className="main-content">
          <Outlet />
        </div>
      </div>
    </>
  );
}
